import React from 'react'
import { Row, Col } from 'reactstrap';
import { Redirect, Switch, Route } from "react-router-dom";
import { MenuDasFuncionalidades } from "../Menu/index";
import { connect } from 'react-redux';
import * as actionsRedux from '../Store/Actions/index';
import { CardCrud } from '../Conteudo/Cards/index';
import { convertToSlug } from '../Basicos/funcoes';
import RodiizioExterna from '../Conteudo/RodiizioExterna';


function AtividadeExternas({ atividades_externas, }) {
    return (
        <Row noGutters={true}>
            <MenuDasFuncionalidades
                funcionalidade={"Atividades Externas"}
                classNavBar="navbar-consultas"
                titulo="Atividades Externas"
            />
            <Col sm={12} md={12} className="col-conteudo">
                <Switch>
                    {atividades_externas.map((subFuncionalidade, indice) => {
                        switch (convertToSlug(subFuncionalidade.descricao)) {
                            case "atividade-externas":
                                return (
                                    <Route
                                        key={subFuncionalidade.url}
                                        path={subFuncionalidade.url}
                                        render={(props) =>  <CardCrud 
                                                                {...props}
                                                                subFuncionalidade={subFuncionalidade}
                                                                indiceSubFuncionalidade={indice}
                                                                funcionalidade={"atividades-externas"} 
                                                            />
                                                }
                                    />
                                );
                            default:
                                return (
                                    <Route
                                        key={subFuncionalidade.url}
                                        path={subFuncionalidade.url}
                                        render={(props) =>  <RodiizioExterna
                                                                {...props}
                                                                subFuncionalidade={subFuncionalidade}
                                                                indiceSubFuncionalidade={indice}
                                                                funcionalidade={"atividades-externas"}
                                                            />
                                                }
                                    />
                                );
                                
                        }
                    })}
                    <Route render={() => <Redirect to="/" />} />
                </Switch>
            </Col>
        </Row>
    )
}
const mapDispatchToProps = (dispatch) => {
    return {
        desativarModal: () => dispatch(actionsRedux.desativarModalSubFuncionalidade()),
    }
}

const mapStateToProps = (state) => {
    return {
        atividades_externas: state.subFuncionalidades['atividades-externas'],
        estruturaModal: state.subFuncionalidades.estruturaModal,
        estadoModal: state.subFuncionalidades.estadoModal,
        adicionar: state.subFuncionalidades.adicionar,
        editarFunc: state.subFuncionalidades.editar,
        tipoAcao: state.subFuncionalidades.tipoAcao,
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AtividadeExternas)